import React, { Component } from "react";
import { CheckLatestBuildupChangesComponent } from "../../generated/graphql";

interface IProps {
  needToCheckForChanges: boolean;
  setNeedToCheckForChanges: (needToCheckForChanges: boolean) => void;
}

class CheckBuildupChanges extends Component<IProps> {
  public getLastDateCheck() {
    const lastDateCheck = localStorage.getItem("lastDateCheck");
    if (!lastDateCheck) {
      return new Date("2000").toISOString();
    }
    return lastDateCheck;
  }

  public render() {
    const { setNeedToCheckForChanges, needToCheckForChanges } = this.props;

    return needToCheckForChanges ? (
      <CheckLatestBuildupChangesComponent
        variables={{ lastDateCheck: this.getLastDateCheck() }}
      >
        {({ error, data }) => {
          if (error) {
            console.error(error);
            return null;
          }
          const previousBuildupCache = JSON.parse(
            localStorage.getItem("buildups")
          );
          const previousTemplateCache = JSON.parse(
            localStorage.getItem("templates")
          );
          if (!previousBuildupCache && previousTemplateCache) {
            return null;
          }

          if (data && data.checkLatestBuildupChanges) {
            const { buildups, templates } = data.checkLatestBuildupChanges;
            const newBuildupArrayIds = buildups.map(b => b.id);

            const newBuildupArray = previousBuildupCache
              .filter((item: any) => !newBuildupArrayIds.includes(item.id))
              .concat(buildups)
              .filter((item: any) => !item.isArchived);

            const newTemplateArrayIds = templates.map(t => t.id);

            const newTemplateArray = previousTemplateCache
              .filter((item: any) => !newTemplateArrayIds.includes(item.id))
              .concat(templates)
              .filter((item: any) => !item.isArchived);

            localStorage.setItem("lastDateCheck", new Date().toISOString());
            localStorage.setItem("buildups", JSON.stringify(newBuildupArray));
            localStorage.setItem("templates", JSON.stringify(newTemplateArray));
            setNeedToCheckForChanges(false);
          }
          return null;
        }}
      </CheckLatestBuildupChangesComponent>
    ) : null;
  }
}
export default CheckBuildupChanges;
